import { Button, Form, Input, message } from "antd";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { createAccountAction, getAccountDetails } from "Sdk/Actions";
import { login } from "Store/reducers/Auth/AuthSlice";
import { emailPattern, FormItemRequiredRule } from "Utility/Constants";
import AuthContainer from "./AuthContainer";
import { Loader } from "Components/Loader";

function Login() {
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  const [form] = Form.useForm();
  const [loginError, setloginError] = useState(false);

  useEffect(() => {
    let email = location?.state?.email;
    let password = location?.state?.password;
    if (email && password) {
      handleSubmit({
        email,
        password,
      });
    }
    form.setFieldsValue({ email, password });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const handleSubmit = async (data) => {
    setisLoading(true);
    Auth.signIn(data?.email, data?.password)
      .then(async (res) => {
        let data = res?.attributes;
        let userData = {
          username: data?.preferred_username,
          email: data?.email,
          name:
            String(data?.preferred_username[0]).toUpperCase() +
            String(data?.preferred_username).slice(1),
        };
        if (res?.attributes?.profile === "false") {
          await handleCreateUser(userData);
        }
        dispatch(
          login({
            token: res?.signInUserSession.accessToken.jwtToken,
          })
        );
        await getAccountDetails(data?.preferred_username);

        navigate("/");
        setisLoading(false);
      })
      .catch((err) => {
        setisLoading(false);
        setloginError(true);
        if (err?.message === "User is not confirmed.") {
          message.info("Seems Like Account is not verified yet.");
          navigate("/confirm-signup", { state: { email: data?.email } });
        } else message.error(err.message);
      });
  };

  const handleCreateUser = async (input) => {
    return createAccountAction(input)
      .then(async (res) => {
        const user = await Auth.currentAuthenticatedUser();
        await Auth.updateUserAttributes(user, {
          profile: "true",
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  if (location?.state?.directLogin && !loginError) {
    return (
      <div className="div-center h-full flex flex-col">
        <Loader />
        <p className="mt-2">
          Hold tight while we sprinkle some digital magic and set up your
          account. 🚀✨
        </p>
      </div>
    );
  }
  return (
    <AuthContainer type={"login"}>
      <Form
        onFinish={handleSubmit}
        layout="vertical"
        requiredMark={false}
        form={form}
        name="login"
        initialValues={{ remember: true }}
        className="space-y-6 login-register-form"
      >
        <Form.Item
          name={"email"}
          rules={[
            FormItemRequiredRule,
            { pattern: emailPattern, message: "Please enter proper email" },
          ]}
        >
          <Input
            placeholder="Email"
            className={"p-2 rounded-md input-border"}
          />
        </Form.Item>

        <Form.Item name="password" rules={[FormItemRequiredRule]}>
          <Input.Password
            placeholder="Password"
            className={"p-2 rounded-md input-border"}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="w-full  rounded-lg"
            loading={isLoading}
          >
            Log In
          </Button>
        </Form.Item>
      </Form>

      <div className="text-center flex flex-col">
        <Link to="/register" className="text-sm hover:underline mb-3">
          Don't have an Account?
        </Link>
        <Link to="/forgot-password" className="text-sm hover:underline">
          Forgot Password?
        </Link>
      </div>
    </AuthContainer>
  );
}

export default Login;
